import { Injectable } from '@angular/core';
import { IContactForm } from '../forms/contact-form/contact-form.component';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { SettingService } from 'src/app/shared/services/setting.service';
import { ApiControllerService } from 'src/app/shared/services/api-controller.service';
import { ITranslatableText } from 'src/app/store/services/store.service';

export interface ISupportConfiguration {
  id?: string;
  merchantId?: string;
  externalProviderId?: string[];
  pageInfoId?: string;
  
  optionsList?: string[];
  giftCardandLoyaltySupportEmails?: ITranslatableText;
  onlineOrderSupportEmails?: ITranslatableText;

  creationDate?: Date;
  editingDate?: Date;
  createdBy: string;
  lastEditedBy: string;
}

export interface IBaseSupportConfigModel {
  merchantId?: string;
}

@Injectable({
  providedIn: 'root'
})
export class SupportService {

  

  constructor(private http: HttpClient,
              private setting: SettingService,
            private apiController: ApiControllerService) { }

  contact(model: IContactForm) : Observable<boolean> {
    return Observable.create(o => {
      //this.http.post(this.setting.apiUrl('Support/ContactUs'), model)
      this.apiController.post(this.setting.apiUrl('Support/ContactUs'), model)
        .pipe(finalize(() => {
          o.complete();
        }))
        .subscribe((data: boolean) => {
          o.next(data);
        });
    });
  }
  uploadContactImage(formData: FormData)
  {
    return Observable.create(o => {
      //this.http.post(this.setting.apiUrl('Support/UploadImage'),formData).pipe(finalize(() => {
      this.apiController.post(this.setting.apiUrl('Support/UploadImage'),formData).pipe(finalize(() => {
        o.complete();
      }))
      .subscribe((data: boolean) => {
        o.next(data);
    
      });
    });
  }

  getSupportConfiguration(baseRequest: IBaseSupportConfigModel): Observable<ISupportConfiguration> {
    return Observable.create(o => {
      this.http.post(this.setting.apiUrl('SupportConfiguration/GetSupportConfiguration'), baseRequest)
        .subscribe((data: any) => {
          o.next(data);
          o.complete();
        });
    })
  }

}
